import { PAYMENT_SETUP_STATUS } from "@constants/panel/common";

// Reads the "this brand hasn't set up how it pays publishers yet" signal off a
// raw `brands/v1/dashboard/accounts` row. While it is pending, the brand
// workspace is locked behind /brand/:brandId/setup (see use-brand-route-guard).
//
// `payment_setup_status` is the single key that decides this: the API only
// carries it once the account has been through onboarding, so a row missing the
// field is un-set-up and shows the gate — as does one still on "pending".
export const isBrandSetupPending = (account = {}) => {
    const status = account?.payment_setup_status;
    return !status || status === PAYMENT_SETUP_STATUS.PENDING;
};

export default isBrandSetupPending;
